import { api } from "@/lib/api";

function urlBase64ToBytes(value) {
  const pad = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("این مرورگر از اعلان پشتیبانی نمی‌کند");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("اجازه نمایش اعلان داده نشد");
  const registration = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToBytes(data.publicKey),
  });
  const body = subscription.toJSON();
  await api.post("/push/subscribe", { endpoint: body.endpoint, keys: body.keys });
  return subscription;
}

export async function disablePush() {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;
  const body = subscription.toJSON();
  await api.delete("/push/subscribe", { data: { endpoint: body.endpoint, keys: body.keys } }).catch(() => {});
  await subscription.unsubscribe();
}

export async function getPushState() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
    const registration = await navigator.serviceWorker.ready;
    return !!(await registration.pushManager.getSubscription());
  } catch {
    return false;
  }
}
